import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-516ae727")

_pushScopeId("data-v-516ae727")
const _hoisted_1 = { class: "ui__ecuDetail_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ECU检测 ")
const _hoisted_4 = { class: "ui__baseInfo_main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ecu-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
    /*#__PURE__*/_createVNode("span", null, "车辆基础信息"),
    /*#__PURE__*/_createVNode("div", { class: "title_line" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ecu-title-right" })
], -1)
const _hoisted_6 = { class: "ecu-content-base" }
const _hoisted_7 = { class: "ui_content_item" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " 车牌号码 ", -1)
const _hoisted_9 = { class: "ui_content_item_value" }
const _hoisted_10 = { class: "ui_content_item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " VIN码 ", -1)
const _hoisted_12 = { class: "ui_content_item_value" }
const _hoisted_13 = { class: "ui_content_item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " 车辆品牌 ", -1)
const _hoisted_15 = { class: "ui_content_item_value" }
const _hoisted_16 = { class: "ui_content_item" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " 车辆年款 ", -1)
const _hoisted_18 = { class: "ui_content_item_value" }
const _hoisted_19 = { class: "ui_content_item" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " 车型名称 ", -1)
const _hoisted_21 = { class: "ui_content_item_value" }
const _hoisted_22 = { class: "ui_content_item" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " 行驶里程 ", -1)
const _hoisted_24 = { class: "ui_content_item_value" }
const _hoisted_25 = { class: "ui_content_item" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "ui_content_item_label" }, " 诊断时间 ", -1)
const _hoisted_27 = { class: "ui_content_item_value" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "ui__line" }, null, -1)
const _hoisted_29 = { class: "ui__normal_main" }
const _hoisted_30 = { class: "ecu-title" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
  /*#__PURE__*/_createVNode("span", null, "检测正常项"),
  /*#__PURE__*/_createVNode("div", { class: "title_line" })
], -1)
const _hoisted_32 = { class: "ecu-title-right" }
const _hoisted_33 = { class: "ecu-content-normal" }
const _hoisted_34 = { class: "ui__normal_list_item_flex" }
const _hoisted_35 = { class: "ui__normal_list_item_left" }
const _hoisted_36 = { class: "ui__normal_list_checkbox" }
const _hoisted_37 = /*#__PURE__*/_createVNode("span", null, "｜", -1)
const _hoisted_38 = { class: "ui__normal_list_item_center" }
const _hoisted_39 = { class: "ui__normal_list_checkitem" }
const _hoisted_40 = { class: "ui__normal_list_item_right" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 正常 ")
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "ui__line" }, null, -1)
const _hoisted_43 = { class: "ui__abnormal_main" }
const _hoisted_44 = { class: "ecu-title" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
  /*#__PURE__*/_createVNode("span", null, "检测异常项"),
  /*#__PURE__*/_createVNode("div", { class: "title_line" })
], -1)
const _hoisted_46 = { class: "ecu-title-right" }
const _hoisted_47 = { class: "ecu-content-abnormal" }
const _hoisted_48 = { class: "ui__abnormal_list_item_flex" }
const _hoisted_49 = { class: "ui__abnormal_list_item_left" }
const _hoisted_50 = { class: "ui__abnormal_list_checkbox" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", null, "｜", -1)
const _hoisted_52 = { class: "ui__abnormal_list_item_center" }
const _hoisted_53 = { class: "ui__abnormal_list_checkitem" }
const _hoisted_54 = { class: "ui__abnormal_list_item_right" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 异常 ")
const _hoisted_56 = {
  key: 0,
  class: "ui__abnormal_list_box"
}
const _hoisted_57 = { class: "ui__abnormal_code" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "ui__abnormal_code_left" }, "故障码", -1)
const _hoisted_59 = { class: "ui__abnormal_code_right" }
const _hoisted_60 = { class: "ui__abnormal_des" }
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "ui__abnormal_des_left" }, "故障描述", -1)
const _hoisted_62 = { class: "ui__abnormal_des_right" }
const _hoisted_63 = { class: "ui__reminder_main" }
const _hoisted_64 = { class: "ui__reminder_title" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("温馨提示 ")
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "ui__reminder_text" }, " 本检测所展示的车辆运行数据均为静态数据，信息仅供参考，268V不对由此产生的任何事故和故障承担责任。 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ecuDetail-header",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.state.ecuBaseInfo.license), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.state.ecuBaseInfo.vin), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.state.ecuBaseInfo.brand), 1)
        ]),
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("div", _hoisted_18, _toDisplayString(_ctx.state.ecuBaseInfo.year), 1)
        ]),
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.state.ecuBaseInfo.modelName), 1)
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.state.ecuBaseInfo.mile), 1)
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("div", _hoisted_27, _toDisplayString(_ctx.state.ecuBaseInfo.checkTime), 1)
        ])
      ])
    ]),
    _hoisted_28,
    _createVNode("div", _hoisted_29, [
      _createVNode("div", _hoisted_30, [
        _hoisted_31,
        _createVNode("div", _hoisted_32, [
          _createVNode("img", {
            class: "ui__normal_icon",
            src: require('@/assets/image/success.png')
          }, null, 8, ["src"]),
          _createTextVNode(_toDisplayString(_ctx.state.normalItemCount) + "项正常 ", 1)
        ])
      ]),
      _createVNode("div", _hoisted_33, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.normalList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui__normal_list_item",
            key: item.index
          }, [
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("p", _hoisted_36, _toDisplayString(item.systemType), 1),
                _hoisted_37
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode("p", _hoisted_39, _toDisplayString(item.systemName), 1)
              ]),
              _createVNode("div", _hoisted_40, [
                _createVNode("img", {
                  class: "ui__normal_list_item_right_icon",
                  src: require('@/assets/image/success.png')
                }, null, 8, ["src"]),
                _hoisted_41
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_42,
    _createVNode("div", _hoisted_43, [
      _createVNode("div", _hoisted_44, [
        _hoisted_45,
        _createVNode("div", _hoisted_46, [
          _createVNode("img", {
            class: "ui__abnormal_icon",
            src: require('@/assets/image/warning.png')
          }, null, 8, ["src"]),
          _createTextVNode(_toDisplayString(_ctx.state.abnormalItemCount) + "项异常 ", 1)
        ])
      ]),
      _createVNode("div", _hoisted_47, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.abnormalList, (itemfather) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui__abnormal_list_item",
            key: itemfather.index
          }, [
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _createVNode("p", _hoisted_50, _toDisplayString(itemfather.systemType), 1),
                _hoisted_51
              ]),
              _createVNode("div", _hoisted_52, [
                _createVNode("p", _hoisted_53, _toDisplayString(itemfather.systemName), 1)
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode("img", {
                  class: "ui__abnormal_list_item_right_icon",
                  src: require('@/assets/image/warning.png')
                }, null, 8, ["src"]),
                _hoisted_55
              ])
            ]),
            (itemfather.items && itemfather.items.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_56, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemfather.items, (itemchild) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "ui__abnormal_list_box_item",
                      key: itemchild.faultCode
                    }, [
                      _createVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createVNode("div", _hoisted_59, _toDisplayString(itemchild.faultCode), 1)
                      ]),
                      _createVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createVNode("div", _hoisted_62, _toDisplayString(itemchild.faultDesc) + "字", 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_63, [
      _createVNode("div", _hoisted_64, [
        _createVNode("img", {
          src: require('@/assets/image/tanhao_icon.png')
        }, null, 8, ["src"]),
        _hoisted_65
      ]),
      _hoisted_66
    ])
  ]))
})